import React from 'react';
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Modules from "../components/Modules";

const ModuleManagement = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout >

        {/* Breadcrumb */}
        <Breadcrumb title="Modules" />

        {/* DashBoardLayerSix */}
        <Modules />



      </MasterLayout>
    </>
  );
}
export default ModuleManagement;